var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoBarResultsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_113_1",
    "data-name": "Componente 113 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.857,
    height: 21.857,
    viewBox: "0 0 21.857 21.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0432a0"
    },
    id: "Trazado_9211",
    "data-name": "Trazado 9211",
    d: "M21.857,51.516V34.342A2.342,2.342,0,0,0,19.516,32H2.342A2.342,2.342,0,0,0,0,34.342V51.516a2.342,2.342,0,0,0,2.342,2.342H19.516A2.342,2.342,0,0,0,21.857,51.516ZM2.342,52.3a.782.782,0,0,1-.781-.781V34.342a.782.782,0,0,1,.781-.781H19.516a.782.782,0,0,1,.781.781V51.516a.782.782,0,0,1-.781.781ZM12.49,38.635v-.781a.39.39,0,0,0-.39-.39H5.074a.39.39,0,0,0-.39.39v.781a.39.39,0,0,0,.39.39H12.1A.39.39,0,0,0,12.49,38.635Zm4.684,4.684v-.781a.39.39,0,0,0-.39-.39H5.074a.39.39,0,0,0-.39.39v.781a.39.39,0,0,0,.39.39H16.783A.39.39,0,0,0,17.174,43.319ZM9.367,48v-.781a.39.39,0,0,0-.39-.39h-3.9a.39.39,0,0,0-.39.39V48a.39.39,0,0,0,.39.39h3.9A.39.39,0,0,0,9.367,48Z",
    transform: "translate(0 -32)",
    fill: "#484848"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBarResultsActive);
export default __webpack_public_path__ + "static/media/ico-bar-results-active.4dc6126240780d26d148af49ba217540.svg";
export { ForwardRef as ReactComponent };